const TerminiPage = () => {
  return (
    <div data-testid="termini-page">
      {/* Hero Section */}
      <section className="bg-[#f5f6fa] py-16 md:py-24">
        <div className="section-container">
          <div className="max-w-3xl mx-auto text-center">
            <h1 className="heading-1 text-[#1a1f36] mb-6">
              Termini e Condizioni
            </h1>
            <p className="body-large">
              Termini e condizioni d'uso del sito
            </p>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="section-padding">
        <div className="section-container">
          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-2xl border border-[#e2e4ed] p-8 md:p-12">
              <p className="text-[#4a5068] mb-8 text-lg">
                L'accesso e l'utilizzo di questo sito implicano l'accettazione dei seguenti termini e condizioni.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">1. Contenuti del sito</h2>
              <p className="text-[#4a5068] mb-6">
                I contenuti presenti sul sito sono forniti a scopo informativo. Il titolare si impegna 
                a mantenerli aggiornati ma non garantisce l'assenza di errori o omissioni.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">2. Proprietà intellettuale</h2>
              <p className="text-[#4a5068] mb-6">
                Tutti i contenuti del sito, inclusi testi, immagini, loghi e grafica, sono protetti 
                da diritti di proprietà intellettuale e non possono essere utilizzati senza autorizzazione.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">3. Limitazione di responsabilità</h2>
              <p className="text-[#4a5068] mb-6">
                Il titolare non è responsabile per eventuali danni derivanti dall'uso delle informazioni 
                presenti sul sito.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">4. Link a siti esterni</h2>
              <p className="text-[#4a5068] mb-6">
                Il sito può contenere collegamenti a siti esterni sui quali il titolare non ha alcun controllo.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">5. Utilizzo del servizio iSiAP</h2>
              <p className="text-[#4a5068] mb-6">
                L'utilizzo del software iSiAP è regolato da specifiche condizioni contrattuali che vengono 
                fornite al momento della sottoscrizione del servizio. L'utente si impegna a utilizzare il 
                software in conformità con le leggi vigenti e con le istruzioni fornite.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">6. Obblighi dell'utente</h2>
              <p className="text-[#4a5068] mb-4">L'utente si impegna a:</p>
              <ul className="list-disc list-inside text-[#4a5068] space-y-2 mb-6">
                <li>fornire informazioni veritiere e accurate</li>
                <li>non utilizzare il sito per scopi illeciti</li>
                <li>non tentare di accedere a aree riservate senza autorizzazione</li>
                <li>rispettare la proprietà intellettuale del titolare</li>
              </ul>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">7. Assistenza e supporto</h2>
              <p className="text-[#4a5068] mb-6">
                Il supporto tecnico è disponibile secondo le modalità e gli orari indicati sul sito. 
                Il titolare si impegna a fornire assistenza tempestiva ma non garantisce la risoluzione 
                immediata di tutti i problemi segnalati.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">8. Legge applicabile</h2>
              <p className="text-[#4a5068] mb-6">
                I presenti termini e condizioni sono regolati dalla legge italiana. Per qualsiasi 
                controversia sarà competente il Foro di Pavia.
              </p>

              <h2 className="text-2xl font-bold text-[#1a1f36] mb-4 mt-8">9. Modifiche</h2>
              <p className="text-[#4a5068] mb-6">
                Il titolare si riserva il diritto di modificare i presenti termini in qualsiasi momento. 
                Le modifiche saranno pubblicate su questa pagina e saranno efficaci dalla data di pubblicazione.
              </p>

              <div className="mt-8 p-6 bg-[#f5f6fa] rounded-xl">
                <p className="text-[#4a5068] text-sm">
                  <strong>Ultimo aggiornamento:</strong> Marzo 2026
                </p>
                <p className="text-[#4a5068] text-sm mt-2">
                  Per qualsiasi domanda relativa ai presenti termini, contattaci all'indirizzo: 
                  <a href="mailto:info@isiap.it" className="text-[#FF6B00] ml-1">info@isiap.it</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TerminiPage;
